import {atom} from "jotai";

export const SelectedConversationAtom = atom(null);
export const CommentConversationAtom = atom(null);
export const DebugIdAtom = atom(null);